import type {
	RowData,
	SortingState,
	TableState_ColumnFiltering,
	TableState_GlobalFiltering,
	TableState_RowPagination,
	TableState_RowSorting,
	PaginationState as TanstackPaginationState,
} from '@tanstack/react-table';

import type { CommonFilters } from '@apple/utils/filters';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from '@apple/utils/pagination/models';

export interface ColumnFilterDef<_TData extends RowData, TValue = unknown> {
	group?: string;
	variant?: FilterVariant;
	label?: string;
	placeholder?: string;
	/** @default 200 */
	debounce?: number;
	sortOrder?: number;
	sortCompareFn?: (a: unknown, b: unknown) => number;
	// HACK: need to find a better way to handle this...
	filterFromString?: (value?: string | null) => TValue;
	// HACK: need to find a better way to handle this...
	getFilterDisplayValue?: (value: unknown) => string;
	minValue?: unknown;
	maxValue?: unknown;
}

export type FilterVariant =
	| 'number'
	| 'number-range'
	| 'number-range-slider'
	| 'text'
	| 'select'
	| 'multi-select'
	| 'switch'
	| 'date'
	| 'date-range'
	| 'false-only-switch'
	| 'segmented-switch';

export type TableVariant = 'apple-table' | undefined;

export type FilterData<T extends Record<string, unknown>> = {
	[K in keyof T]: T[K];
};

export interface DataTableQueryOptions<TFilters extends FilterData<TFilters>> {
	pagination: TanstackPaginationState;
	filters: TFilters;
	commonFilters?: CommonFilters;
	sorting?: SortingState;
}

export interface DataTableState
	extends TableState_GlobalFiltering,
		TableState_RowSorting,
		TableState_RowPagination,
		TableState_ColumnFiltering {}

export type FieldMap<TRow extends RowData, TFilters extends FilterData<TFilters>> = {
	row: keyof TRow;
	filter: keyof TFilters;
};

export const emptyTableState = {
	columnFilters: [],
	sorting: [],
	pagination: {
		pageIndex: DEFAULT_PAGE_INDEX,
		pageSize: DEFAULT_PAGE_SIZE,
	},
	globalFilter: undefined,
} satisfies DataTableState;
